import { Currency } from 'commons/types/Currency.enum';

export const formatCurrencyBR = (value: number) => {
  if (value === 0) return '0,00';

  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: Currency.BRL,
  });
  return formattedValue.format(value);
};

export const formatDecimalBR = (value: number) => {
  if (value === 0 || value === null || value === undefined) return '';

  const formattedValue = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue.format(value);
};

export const parseDecimalBR = (value: string): number => {
  if (!value || value.trim() === '') return 0;

  const cleanValue = value.replace(/\s/g, '').replace(',', '.');
  const parsedValue = parseFloat(cleanValue);
  return isNaN(parsedValue) ? 0 : parsedValue;
};

export const applyMoneyMask = (value: string): string => {
  const onlyNumbers = value.replace(/\D/g, '');

  if (!onlyNumbers) return '';
  const numberValue = parseInt(onlyNumbers) / 100;

  const formattedValue = numberValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedValue;
};

export const parseMaskedValue = (maskedValue: string): number => {
  if (!maskedValue || maskedValue.trim() === '') return 0;

  const cleanValue = maskedValue.replace(/[^\d,]/g, '');

  const numberValue = parseFloat(cleanValue.replace(',', '.'));

  return isNaN(numberValue) ? 0 : numberValue;
};

export const parseDecimalAR = (value: string | undefined | null): number => {
  const raw = value ?? '';
  const parsed = Number.parseFloat(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) return 0;
  return Math.floor(parsed * 100) / 100;
};

export const formatDecimalMX = (value: number): string => {
  if (value === 0 || value === null || value === undefined) return '';
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const parseDecimalMX = (value: string): number => {
  if (!value || value.trim() === '') return 0;
  const onlyNumbers = value.replace(/[^0-9]/g, '');
  if (!onlyNumbers) return 0;
  return parseInt(onlyNumbers) / 100;
};
